module.exports = __webpack_public_path__ + "static/media/heart44.1a1be3b9.svg";